import React, { Component, Fragment } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import Topbar from '../Topbar/Topbar';
import Main from '../Main/Main';
import Permissions from './Permissions';

class Settings extends Component {
  render() {
    return (
      <Fragment>
        <Sidebar highlightNavItemIndex={7} />
        <Topbar className="font-bold text-lg">Settings</Topbar>
        <Main>
          <Permissions />
        </Main>
      </Fragment>
    );
  }
}

export default  Settings;
